module.exports = __webpack_public_path__ + "static/media/startup-img.5135159a.png";